var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostEffective(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2949 14.8355L26.7949 3.33547C26.5946 3.13443 26.3566 2.97492 26.0945 2.86607C25.8324 2.75722 25.5514 2.70118 25.2676 2.70117H5.14258C4.57071 2.70117 4.02226 2.92835 3.61788 3.33272C3.21351 3.7371 2.98633 4.28555 2.98633 4.85742V24.9824C2.98565 25.5073 3.17744 26.0143 3.52539 26.4073C3.55235 26.4397 3.5811 26.472 3.61524 26.508L15.1152 38.008C15.3158 38.2084 15.554 38.3672 15.8161 38.4754C16.0782 38.5837 16.359 38.6391 16.6426 38.6387H36.7676C37.3395 38.6387 37.8879 38.4115 38.2923 38.0071C38.6967 37.6027 38.9238 37.0543 38.9238 36.4824V16.3574C38.9238 15.7869 38.6977 15.2396 38.2949 14.8355ZM27.4238 10.0684L31.5566 14.2012H27.4238V10.0684ZM14.4863 31.2715L10.3535 27.1387H14.4863V31.2715ZM14.4863 22.8262H7.29883V10.0684L14.4863 17.2559V22.8262ZM10.3535 7.01367H23.1113V14.2012H17.541L10.3535 7.01367ZM23.1113 18.5137V22.8262H18.7988V18.5137H23.1113ZM18.7988 34.3262V27.1387H24.3691L31.5566 34.3262H18.7988ZM34.6113 31.2715L27.4238 24.084V18.5137H34.6113V31.2715Z",
    fill: "url(#paint0_linear_60_562)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_562",
    x1: 7.51564,
    y1: -19.4493,
    x2: 49.0644,
    y2: -10.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883 0.669922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffective);
export default __webpack_public_path__ + "static/media/cost-effective.83c3eb39ef0a67f2375ad0c7866222aa.svg";
export { ForwardRef as ReactComponent };